<div *ngIf="errorState" class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-header>
      <mat-card-title>Reset password</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <span *ngIf="errorState === 'linkError'">
        There was a problem with the password reset link. Trying copying link
        again.
      </span>
      <span *ngIf="errorState === 'tokenNotFound'">
        The password reset link could not be found.
      </span>
      <span *ngIf="errorState === 'tokenExpired'">
        The password reset link expired.
      </span>
      <a routerLink="/login" class="text-link"> Login to your account. </a>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="!errorState && !submitSuccess && form" class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-header>
      <mat-card-title>Reset password </mat-card-title>
      <mat-card-subtitle>Enter your new password. </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="submit(form.value)">
        <div class="form-group">
          <p>Email: {{ email }}</p>
          <mat-form-field class="simple-form-field-100">
            <mat-label>New password</mat-label>
            <input
              type="password"
              matInput
              placeholder="New password"
              name="password"
              id="password"
              formControlName="password"
              autocomplete="new-password"
              required
            />
            <mat-error>{{ passwordErrorMessage }}</mat-error>
          </mat-form-field>
          <mat-progress-bar
            [color]="updatePasswordProgressColor(passwordGuessesLog10)"
            mode="determinate"
            value="{{ passwordProgressBarValue.toString() }}"
          >
          </mat-progress-bar>
          <br />
          <button
            [disabled]="waiting || disableSubmit"
            class="simple-form-button"
            color="primary"
            mat-raised-button
            type="submit"
            value="submit"
          >
            Submit
          </button>
          <mat-progress-spinner
            *ngIf="waiting"
            color="primary"
            mode="indeterminate"
            class="simple-form-spinner"
            [diameter]="22"
          >
          </mat-progress-spinner>
          <span *ngIf="formErrorMessage" class="text-error-color">
            {{ formErrorMessage }}
          </span>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<div *ngIf="submitSuccess" class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <mat-card-header>
      <mat-card-title>Reset password</mat-card-title>
    </mat-card-header>
    <mat-card-content
      >Your password has been reset.
      <a routerLink="/login" class="text-link"> Login to your account. </a>
    </mat-card-content>
  </mat-card>
</div>
